export class ListBackupZeroEtlPoliciesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupZeroEtlPolicies",
            "baseName": "backupZeroEtlPolicies",
            "type": "Array<BackupZeroEtlPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupZeroEtlPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
